import React, { useEffect, useState, useRef, useCallback } from 'react';
import { get } from '@/features/shared/lib/api';
import ForceNetwork from '@/features/researcher/components/charts/ForceNetwork';
import PnuCoResearchers from '@/features/researcher/components/PnuCoResearchers';
import ExternalCoResearchers from '@/features/researcher/components/ExternalCoResearchers';

export default function CoResearchersTab() {
  const [internal, setInternal] = useState([]);
  const [external, setExternal] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);
  // 첫 로딩인지 추적 (첫 API 호출일 때만 로딩 컴포넌트 표시)
  const isFirstLoadRef = useRef(true);
  const didFetchRef = useRef(false);
  // 현재 사용자의 scholar_id (마이페이지에서는 rmVars.scholar_id 사용)
  const userId = typeof rmVars !== 'undefined' && rmVars?.scholar_id ? rmVars.scholar_id : null;
  // ForceNetwork에 전달할 record 객체
  const record = userId ? { scholar_id: userId, id: userId } : null;

  // fetchList 함수를 외부로 분리하여 재사용 가능하도록
  const fetchList = useCallback(async () => {
    if (!userId) return;

    try {
      // 첫 로딩일 때만 loading 상태를 true로 설정
      if (isFirstLoadRef.current) {
        setLoading(true);
      }
      setErr(null);
      // get coworkers (internal/external)
      const data = await get(`/rm/v1/researcher/${encodeURIComponent(userId)}/coworker`, {
        params: { size: 30 },
      });

      const ok = data?.status === true || data?.success === true;
      const res = data?.result || data;
      const inArr = res?.internal || [];
      const exArr = res?.external || [];

      if (ok) {
        setInternal(Array.isArray(inArr) ? inArr : []);
        setExternal(Array.isArray(exArr) ? exArr : []);
        didFetchRef.current = true;
      } else {
        setErr(res?.message || 'Failed to load coworker data');
      }
    } catch (e) {
      setErr(e?.response?.data?.message || e.message);
    } finally {
      if (isFirstLoadRef.current) {
        setLoading(false);
        isFirstLoadRef.current = false; // 첫 로딩 완료 후 플래그 해제
      }
    }
  }, [userId]);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  return (
    <div className="active pt-[50px] lg:pt-[60px]">
      {err && <div className="mb-4 text-red-600 text-sm">에러: {String(err)}</div>}

      <div>
        <h3 className="mb-4 text-[18px] font-bold leading-[100%] lg:mb-6">Social network of PNU co-Researcher</h3>
        <div className="p-[10px] border border-[#E4E8F1] rounded-[12px]">
          <ForceNetwork record={record} height={460} highlightedLinkColor="#B6C3DC" />
        </div>
      </div>

      <div className="mt-[50px] lg:mt-[60px]">
        <h3 className="mb-4 text-[18px] font-bold leading-[100%] lg:mb-6">Co-Researchers in PNU</h3>
        <PnuCoResearchers active={true} data={internal} loading={loading} />
      </div>

      <div className="mt-[50px] lg:mt-[60px]">
        <h3 className="mb-4 text-[18px] font-bold leading-[100%] lg:mb-6">External Co-Researchers</h3>
        <ExternalCoResearchers active={true} data={external} loading={loading} perPage={6} error={err} />
      </div>
    </div>
  );
}
